export function getFirstName(fullName: string): string {
  const names = fullName.trim().split(' ');

  return names.length > 0 ? names[0] : fullName;
}
